import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { CatalogoService } from 'src/app/aplicaciones-modulos/distribuidores/services/catalogo.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { IndicadoresVivosVModel, IndicadoresVivosVModelInterface } from '../../models/indicadoresVivosVModel';
import { CatalogoIndicadoresService } from '../../services/catalogo-indicadores.service';
import { indicadoresVivosModulo } from '../../diccionarios/indicadoresVivosModulo';
import { IndicadoresVivosService } from '../../services/indicadores-vivos.service';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-upload-csv-sell-out',
  templateUrl: './upload-csv-sell-out.component.html',
  styleUrls: ['./upload-csv-sell-out.component.css']
})

export class UploadCsvSellOutComponent implements OnInit {

  titulo = 'Carga de Presupuesto Sell Out';
  mostrarFormulario = false;

  textoBuscar = '';
  gridApi: any;
  gridColumnApi: any;
  columnDefs: any[];
  frameworkComponents: any;
  rowSelection: any;
  rowData: any[] = [];

  @ViewChild('fileInput') fileInput: ElementRef;
  formulario: FormGroup;

  loading: boolean = false;
  listaVacia: boolean = true;

  modulo: any = {};

  year = (new Date()).getFullYear();

  cmbAnio = [
    { clave: this.year, valor: this.year.toString() },
    { clave: this.year + 1, valor: (this.year + 1).toString() },
    { clave: this.year + 2, valor: (this.year + 2).toString() },
  ];

  DAT_BTNS: any;
  DAT_MSG: any;
  DAT_BTNCSS: any;

  modelGrid: any;
  csv: string;
  objSelected: any = {};
  listaVaciaCli: boolean = true;
  errorData: boolean = true;
  cmbOpciones: { clave: number; valor: string; }[];

  cmbOpcionesV2: any[] = [
    { clave: true, valor: 'SI' },
    { clave: false, valor: 'NO' }
  ]

  cmbTipoDePresupuesto: any[] = [
    { clave: 1, valor: 'LE-COMERCIAL' },
    { clave: 2, valor: 'LE-COMISIONES' }
  ]

  constructor(
    public fb: FormBuilder,
    private _util: UtilsService,
    private catalogo: CatalogoService,
    private _catalogo: CatalogoIndicadoresService,
    private _indicadores: IndicadoresVivosService,
  ) { }

  ngOnInit() {
    this.cmbOpciones = this._catalogo.catalogoOpciones();
    this.formulario = this.fb.group({
      anio: ['', [Validators.required]],
      multipart: ['', [Validators.required]],
    });

    const innClase = new IndicadoresVivosVModel();
    this.modelGrid = innClase.devolverGrid();

    this.modulo = indicadoresVivosModulo;
    this.DAT_BTNS = this.modulo.button.buttonsNombre;
    this.DAT_MSG = this.modulo.mensajes;
    this.DAT_BTNCSS = this.modulo.button.buttonsCss;
    this.cargarIconosFiltros();
    this.cargarGrid();

    this.formulario.get('anio').valueChanges
      .subscribe((resp) => {
        this.getFormValidationErrors();
      });

    this.formulario.get('anio').setValue(this.year);

  }

  /** FUNCIONES */
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  cargarIconosFiltros() {
    this.csv = this.catalogo.catalogoAsesorIcon().csv;
  }

  changeRowColor(params) {
    let data = params.data;
    if (data.correct != undefined) {
      if (data.correct === true) {
        return {
          'background-color': 'lightgreen',
          'color': 'black',
          'font-weight': 'bold',
          'font-size': '14px'
        };
      }
      else {
        return {
          'background-color': '#FFC0CB',
          'color': 'black',
          'font-weight': 'bold',
          'font-size': '14px'
        };
      }
    }
    return true;
  }

  cargarGrid() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'ESTADO',
        sortable: true,
        filter: true,
        width: 200,
        cellStyle: this.changeRowColor.bind(this),
        valueGetter: function (params: any) {
          return (params.data.correct === true) ? 'CORRECTO' : 'INCORRECTO';
        }
      },
      {
        headerName: 'Año',
        field: this.modelGrid.anio,
        filter: true,
        width: 120,
        sortable: true
      },
      {
        headerName: 'Mes',
        field: this.modelGrid.mes,
        filter: true,
        width: 120,
        sortable: true
      },
      {
        headerName: 'Cod.Vendedor',
        field: this.modelGrid.codigoVendedor,
        filter: true,
        width: 150,
        sortable: true
      },
      {
        headerName: 'Nom.Vendedor',
        field: this.modelGrid.nombreVendedor,
        filter: true,
        width: 270,
        sortable: true
      },
      {
        headerName: 'Cod.Cliente',
        field: this.modelGrid.codigoCliente,
        filter: true,
        width: 150,
        sortable: true
      },
      {
        headerName: 'Nom.Cliente',
        field: this.modelGrid.nombreCliente,
        filter: true,
        width: 270,
        sortable: true
      },
      {
        headerName: 'Cod.Material',
        field: this.modelGrid.material,
        filter: true,
        width: 150,
        sortable: true
      },
      {
        headerName: 'Nom.Material',
        field: this.modelGrid.nombreMaterial,
        filter: true,
        width: 270,
        sortable: true
      },
      {
        headerName: 'Cajas',
        field: this.modelGrid.cajas,
        filter: true,
        width: 150,
        sortable: true
      },
      {
        headerName: 'Kilos',
        field: this.modelGrid.kilos,
        filter: true,
        width: 150,
        sortable: true
      },
      {
        headerName: 'Dolares',
        field: this.modelGrid.dolares,
        filter: true,
        width: 150,
        sortable: true
      },
      {
        headerName: 'Clientes Efectrivos',
        field: this.modelGrid.clientesEfectivos,
        filter: true,
        width: 150,
        sortable: true
      },
      {
        headerName: 'ERROR',
        field: 'error.errorCampo',
        cellStyle: this.changeRowColor.bind(this),
        filter: true,
        width: 600,
        sortable: true
      },
    ];
    this.rowSelection = 'multiple';
  }

  regresar() {
    this.mostrarFormulario = false;
    this.rowData = [];
    this.formulario.reset();
  }

  onFileSelect(event) {
    let allowedExtensions = /(.csv)$/i;
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (!allowedExtensions.exec(file.name)) {
        this.formulario.get('multipart').setValue('');
        this._util.mensajeErrorVisto('El tipo de archivo no es valido, el tipo de archivo permitido es "CSV" ', true, 9000);
        this.fileInput.nativeElement.value = '';
      } else {
        this.formulario.get('multipart').setValue(file);
      }
    }
  }

  setFormData(data: any): FormData {
    const formData = new FormData();
    // formData.append('multipart', data.multipart);
    formData.append('file', new Blob([data.multipart], { type: 'text/csv' }), 'file');
    return formData;
  }

  validarRowData() {
    this.errorData = true;
    this.rowData.forEach(e => {
      if (e.correct) {
        this.errorData = false;
      }
    });
  }

  enviarFormulario() {

    const anio = this.formulario.get('anio').value;

    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea enviar el siguiente archivo?',
        text: '',
        action: 'Enviar',
        funcion: this._indicadores.procesarCsvSellOut(this.setFormData(this.formulario.value), anio),
        loading: true,
        context: this,
      }
    ).then((res: any[]) => {
      // debugger
      this.mostrarFormulario = true;
      this.rowData = res;
      if (this.rowData.length > 0) {
        this.listaVacia = false;
        this.validarRowData();
      } else {
        this.listaVacia = true;
      }
    }).catch((err) => {
      console.log('Error ' + err);
      this.rowData = [];
      this.listaVacia = true;
    });
  }

  guardar() {
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea guardar el siguiente listado de Presupuesto?',
        text: '',
        action: 'Guardar',
        funcion: this._indicadores.saveCsvSellOut(this.rowData),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this._util.mensajeOKVisto(res, true, 10000);
      this.downloadDataCsv();
      this.regresar();
    }).catch((err) => {
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.message, true, 3000);
    });
  }


  downloadCsvFormato() {
    let cabecera: any[] = [['CLIENTE', 'PRODUCTO', 'DOLARES', 'KILOS', 'CAJAS', 'MES', 'VENDEDOR', 'CLIENTES_EFECTIVOS']];
    const data: any[] = [
      {'cliente': '100000120', 'PRODUCTO': '3031008', 'dolares': 100, 'kilos': 10.5, 'cajas': 10, 'mes': 10, 'vendedor': '311300', 'CLIENTES_EFECTIVOS': 10 }
    ];
    let name: string = "formato-plantilla.csv";
    this._util.exportCSV(cabecera, data, name);
  }

  downloadDataCsv() {
    let data: any = [];
    let cabecera: any[] = [['TIPO', 'ANIO', 'MES', 'VENDEDOR', 'NOM.VENDEDOR', 'CLIENTE', 'NOM.CLIENTE', 'PRODUCTO', 'DES.PRODUCTO', 'CAJAS', 'KILOS', 'DOLARES', 'CLIENTES_EFECTIVOS', 'Estado', 'Linea', 'Error']];
    let clonData = this.rowData.map((x) => Object.assign({}, x));
    clonData.forEach((e) => {
      if (!e.correct) {
        data.push(
          {
            tipo: (e.tipo == 1) ? 'CANAL MODERNO' : 'CANAL TRADICIONAL',
            anio: (e.anio === undefined) ? '' : e.anio,
            mes: (e.mes === undefined) ? '' : e.mes,
            codigoVendedor: (e.codigoVendedor === undefined) ? '' : e.codigoVendedor,
            nombreVendedor: (e.nombreVendedor === undefined) ? '' : e.nombreVendedor,
            codigoCliente: (e.codigoCliente === undefined) ? '' : e.codigoCliente,
            nombreCliente: (e.nombreCliente === undefined) ? '' : e.nombreCliente,
            codigoArticulo: (e.material === undefined) ? '' : e.material,
            nombreArticulo: (e.nombreMaterial === undefined) ? '' : e.nombreMaterial,
            cajas: (e.cajas === undefined) ? '' : e.cajas,
            kilos: (e.kilos === undefined) ? '' : e.kilos,
            dolares: (e.dolares === undefined) ? '' : e.dolares,
            clientesEfectivos: (e.clientesEfectivos === undefined) ? '' : e.clientesEfectivos,
            estado: (e.correct) ? 'CORRECTO' : 'INCORRECTO',
            linea: (e.error === undefined) ? '' : e.error.linea,
            errorCampo: (e.error === undefined) ? '' : e.error.errorCampo,
          }
        );
      }
    });
    let name: string = "REGISTRO_ERRORES_SELLOUT.csv";

    this._util.exportCSV(cabecera, data, name);
    this._util.mensajeOKToast('El archivo csv se exporto correctame.');
  }

  setCodigoArticulo({ codigoArticulo, contenedor }) {
    if (codigoArticulo !== undefined && contenedor !== undefined && contenedor !== "") {
      return `${codigoArticulo}/${contenedor}`
    } else {
      if (codigoArticulo !== undefined) {
        return `${codigoArticulo}`;
      } else {
        return '';
      }
    }
  }

  getFormValidationErrors() {

    console.log('%c ==>> Validation Errors: ', 'color: red; font-weight: bold; font-size:25px;');

    let totalErrors = 0;

    Object.keys(this.formulario.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.formulario.get(key).errors;
      if (controlErrors != null) {
        totalErrors++;
        Object.keys(controlErrors).forEach(keyError => {
          console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });

    console.log('Number of errors: ', totalErrors);
  }

}
